import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import { useUnleashContext, useFlag } from '@unleash/proxy-client-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  differenceInCalendarDays,
  isValid as isValidDate,
  parseISO,
  startOfWeek,
  isAfter,
} from 'date-fns';
import { useConfigCatFlag } from '../context';

import * as userActionsTypes from '../store/actions/user.actions';
import * as auctionsActionsTypes from '../store/actions/auction.actions';
import * as uiActionsTypes from '../store/actions/ui.actions';
import { listAutoBidVehicles, listAllAutoBidVehicles } from '../store/autobid/effects';

import { defineSupperOfferAuctions } from '../utils/auction';
import { scrollTop } from '../utils/misc';
import { canShowFreeShippingDialog } from '../utils/freeShippingDialog';
import { checkToken } from '../utils';
import { sortAuctionsByFilter } from '../utils/sorting';

import { useFilter } from '../hooks/useFilter';
import { useLaunchWindowsConfig } from '../hooks/useLaunchWindowsConfig';
import { resolveNonClubRelease } from '../utils/launchWindows';
import { UserFavoriteInspectionsContextProvider } from '../context/FavoriteContext';
import { favoriteService } from '../services/favorite';
import { checkFinancingEnabled } from '../services/fincredit';
import { fetchUpcomingDisputesCount } from '../services/upcomingDisputes';

import ConfirmationModal from '../components/shared/confirmation-modal/ConfirmationModal.jsx';
import MakeBidConfirmationModal from '../components/shared/make-offer/MakeBidConfirmationModal.jsx';
import { Layout } from '../components';
import { Box, Flex } from '../components/abstract';
import Loading from '../components/shared/loading/Loading';
import ParticipatingAuctionsList from '../components/NewAuctionsList/ParticipatingAuctionsList';
import NewOffersList from '../components/NewAuctionsList/NewOffersList';
import ClubeOffersList from '../components/NewAuctionsList/ClubeOffersList/index.jsx';
import HighlightOffersList from '../components/NewAuctionsList/HighlightOffersList';
import NotificationsList from '../components/NewAuctionsList/NotificationsList';
import { WarningNotificationSnack } from '../components/update-contact-info/warning-notification-snack';
import NewOffersFilters from '../components/filters/new-offers-filters';
import FilterNavigation from '../components/filters/components/filter-navigation';
import MobileNewOffersFilters from '../components/filters/mobile-new-offers-filters';
import ModalTemplate from '../components/filters/components/modal-template';
import {
  NewOffersContainer,
  LoadingAuctions,
  NewOffersBody,
  FilterSide,
  CarList,
} from '../components/auctions-page-styles';
import FreeShippingDialog from '../components/freeShippingDialog';
import { CannotSelectWithActiveCategoriesModal } from '../components/Modals/CannotSelectWithActiveCategoriesModal';
import { NewCarousel, NewRecommendedList } from '../components/NewCarousel';
import { EmptyState } from '../components/enhanced/EmptyState';
import Disputa360Banner from '../components/shared/Disputa360Banner';

import { MdClose } from 'react-icons/md';
import FireIcon from '../images/fire-icon-1x.png';
import clubeSession from '../images/icons/clubeSession.svg';
import LoadingGif from '../images/loading.gif';

import { AppConstants } from '../constants/appConstants';

import { usePreferences } from '../hooks/usePreferences';
import { deauthenticate } from '../store/actions/authentication.actions';
import { sendEvent } from '../helpers/googleAnalytics';
import { RecommendedIcon } from '../components/Icons';
import { useSegment } from '../hooks/useSegment';
import { listUserPreferences } from '../store/orderCars/effects';
import { FincredCard } from '../components/NewAuctionsList/Components/FincredCard';
import initAmplitude, { trackEvent } from '../utils/amplitude';
import { PREFERENCES_CONFIG_KEY } from '../constants/modalConstants';
import {
  getLastDealerRedirectLog,
  registerDealerRedirectLog,
  sendDealerWithoutPrefersEvent,
} from '../services/dealerPreferencesRedirect';
// import { mockAuctions } from '../data/mockAuctions.js';
// import { participatingAuctions } from '../data/mockAuctionsParticipate';

export const ListsTitle = styled.div`
  align-items: center;
  gap: 0 8px;
  min-height: 28px;
  display: flex;
  white-space: nowrap;

  h5 {
    font-style: normal;
    font-family: 'Rubik';
    font-weight: bold;
    line-height: 28px;
    color: ${({ color }) => color ?? '#2f3741'};
    font-size: 24px;
  }

  h6 {
    font-style: normal;
    font-weight: bold;
    line-height: 20px;
    color: ${({ color }) => color ?? '#2f3741'};
    font-size: 24px;
  }

  img {
    margin-right: 10px;
  }
`;

export const ClubeListscaption = styled.div`
  align-items: flex-start;
  min-height: 28px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;

  h6 {
    font-style: normal;
    font-family: 'Rubik';
    font-weight: bold;
    line-height: 20px;
    color: ${({ color }) => color ?? '#2f3741'};
    font-size: 16px;
    margin: 0;
    width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  p {
    font-style: normal;
    font-family: 'Rubik';
    font-weight: normal;
    line-height: 20px;
    color: ${({ color }) => color ?? '#2f3741'};
    font-size: 16px;
    margin: 0;
    width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media screen and (max-width: 768px) {
    h6,
    p {
      font-size: 14px;
      line-height: 18px;
    }
  }

  @media screen and (max-width: 480px) {
    h6,
    p {
      font-size: 13px;
      line-height: 16px;
    }
  }
`;

const PreferenceButton = styled.button`
  background: none;
  border: none;
  outline: none;
  text-decoration: underline;
  font-size: 16px;
  color: #003a76;
  cursor: pointer;
  margin-bottom: 20px;
  padding: 0;
  text-align: start;
  font-family: 'Rubik';

  @media screen and (max-width: 1024px) {
    margin-bottom: 16px;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 325px;
  padding: 6px 0;
  height: 40px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 400;
  background-color: #fff;
  /* color: #ffffff; */
  font-family: 'Roboto';
  border: none;
  margin: 1rem 0;
  &:disabled {
    background-color: #c4c4c4;
  }
  @media screen and (min-width: 1024px) {
    margin: 0 0.75rem;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Recommended = styled(Content)`
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  background-color: #f2f8ff;

  @media screen and (max-width: 1024px) {
    padding: 8px;
    margin-bottom: 24px;
  }
`;

Recommended.Content = styled(Content)`
  max-width: 1630px;
`;

Recommended.Title = styled(Content)`
  color: #2f3741;
  font-size: 24px;
  font-family: 'Rubik';
  font-weight: 600;
`;

const TAB_NAME = {
  0: 'Novas Ofertas',
  1: 'Participando',
  2: 'Notificações',
};

// Flag de controle para evitar que a regra de redirecionamento de preferências
// execute mais de uma vez por carregamento de página (e crie logs duplicados)
let dealerPreferencesRedirectAlreadyHandled = false;

export const AuctionsLayout = ({
  user,
  auctions,
  ui,
  allRequestOnGoing,
  loadingHistoricsAuctions,
  historicsLoaded,
  allCarsFetched,
  isParticipatingInNewAuctions,
  isProfileOutdated,
  auctionsActions,
  uiActions,
  listAutoBidVehicles,
  listAllAutoBidVehicles,
}) => {
  const [state, setState] = useState({ tab: 0 });
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [displayWidth, setDisplayWidth] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [type, setType] = useState(null);
  const [staticAuctions, setStaticAuctions] = useState([]);
  const [displaySimulationBanner, setDisplaySimulationBanner] = useState(false);
  const [upcomingDisputesCount, setUpcomingDisputesCount] = useState(undefined);
  const [size, setSize] = useState(window.screen.width);

  const applyedFilter = useSelector(state => state.ui.filters.newOffersFiltersApplyed);
  const { userPreferences, loaded: userPreferencesLoaded } = useSelector(state => state.orderCars);

  const { userProfileLoading } = useSelector(state => state.user?.defaultUserProfile || []);
  const { profile } = useSelector(state => state.user.profile || {});

  const defaultUserProfile = useSelector(state => state.user.defaultUserProfile);
  const verificationProfile = defaultUserProfile?.profile?.find(p => p.default === true);

  const history = useHistory();
  const location = useLocation();
  const benefitsClub = useSelector(state => {
    const email = state.user.profile?.email ?? '';
    return email.endsWith('@instacarro.com') || (state.user.profile?.benefitsClub ?? false);
  });

  // Config das janelas de subida de lotes — define a liberação para não-clube.
  const { days: launchWindowsDays } = useLaunchWindowsConfig();

  const dispatch = useDispatch();
  const updateContext = useUnleashContext();
  const enabled = useFlag('auto-bid');
  const enabledOrderCars = useFlag('order-cars');
  const enabledSimulationBanner = useFlag('banner-simulacao');
  const enabledRecommended = useFlag('recommendations-redesign-SUI-1062');
  const enabledProfileVerification = useFlag('profile-verification-redirect');
  const enabledAutoOpenPreferencesModal = useFlag('auto-open-preferences-modal');
  const checkPreferences90Days = useFlag('re-registration-of-preferences');
  const enabledProximasDisputas = useFlag('leilao_proximas_disputas_enabled');
  const enabledDealerWithoutPrefers = useFlag('dealer_without_prefers');
  const enabledDisputa360Banner = useFlag('banner-disputa-360');

  // ConfigCat feature flags

  const { recommendedCars } = usePreferences();
  const { filtredAuctions, filterList, clearFilter } = useFilter();
  const { page } = useSegment();

  function onConversationsAPIReady() {
    var _hsq = window._hsq ?? [];
    console.log('ready');
    _hsq.push([
      'identify',
      {
        email: user?.email,
      },
    ]);
    _hsq.push(['trackPageView']);
    setTimeout(() => {
      console.log('refresh');
      window.HubSpotConversations.widget.refresh();
    }, 1000);
  }

  function sendIdentify() {
    if (window.HubSpotConversations) {
      onConversationsAPIReady();
    } else {
      window.hsConversationsOnReady = [onConversationsAPIReady];
    }
  }
  const fetchData = async () => {
    try {
      const response = await checkFinancingEnabled(user?.email);
      setDisplaySimulationBanner(response);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (enabledSimulationBanner) {
      fetchData();
    }
  }, [enabledSimulationBanner]);

  useEffect(() => {
    if (!user.email.includes('@instacarro.com')) {
      // Inicializar o Amplitude com as informações do usuário
      const amplitude = initAmplitude(user);

      // Rastrear evento de visualização da página
      trackEvent('view_auctions_page', {
        dealershipId: user?.id,
        dealershipEmail: user?.email,
        dealershipName: user?.dealershipName,
        relatedNinja: profile?.relatedNinja,
        tabName: TAB_NAME[state.tab],
      });
    }

    analytics.identify(user.id, {
      userId: user?.id,
      dealershipName: user?.dealershipName,
      email: user?.email,
      relatedNinja: profile?.relatedNinja,
    });
  }, [user, profile]);

  useEffect(() => {
    page(TAB_NAME[state.tab]);
    trackEvent('change_tab', {
      tabName: TAB_NAME[state.tab],
      dealershipId: user?.id,
    });
  }, [state.tab]);

  useEffect(() => {
    listAutoBidVehicles(user.id, user.isNinja());
  }, [user.id]);

  useEffect(() => {
    updateContext({ userId: user?.email });
  }, [user?.email]);

  useEffect(() => {
    if (user.isNinja() || !enabled) {
      listAllAutoBidVehicles();
    }
  }, [user.isNinja, enabled]);

  useEffect(() => {
    auctionsActions.fetchAuctions();
  }, [auctionsActions.fetchAuctions]);

  useEffect(() => {
    if (auctions.detailedAuction?.auction?.participating) setState({ tab: 1 });

    if (history.location?.state?.from?.includes('detalhes')) setState({ tab: 0 });

    if (state.tab === 2) auctionsActions.SetNotificationsCount(0);

    authenticateLogin();
    dispatch(listUserPreferences(user.id));
    dispatch(userActionsTypes.getDefaultUserProfile());
  }, []);

  useEffect(() => {
    const tabFromState = location.state?.tab;
    if (
      location.pathname === '/' &&
      typeof tabFromState === 'number' &&
      tabFromState >= 0 &&
      tabFromState <= 3
    ) {
      setState(prev => ({ ...prev, tab: tabFromState }));
      history.replace('/', {});
    }
  }, [location.pathname, location.state]);

  // Verificar se deve ir para a página de preferências automaticamente

  useEffect(() => {
    // Não executa se já estiver na página de preferências
    if (history.location.pathname === '/preferencias') {
      return;
    }
    // Só avalia após as preferências terem sido carregadas
    if (!userPreferencesLoaded) {
      return;
    }

    const run = async () => {
      const hasNoPreferences =
        !userPreferences ||
        !userPreferences.id ||
        !userPreferences.preferences ||
        !userPreferences.preferences.length;

      const isDealer =
        !!user &&
        typeof user.isLoja === 'function' &&
        user.isLoja() &&
        (typeof user.isNinja !== 'function' || !user.isNinja());

      // Regra de redirecionamento automático para lojista sem preferências a cada 7 dias
      // controlada pela feature flag "dealer_without_prefers"
      if (
        enabledDealerWithoutPrefers &&
        hasNoPreferences &&
        isDealer &&
        !dealerPreferencesRedirectAlreadyHandled
      ) {
        try {
          const lastLog = await getLastDealerRedirectLog(user.id);
          let shouldRedirectForPreferences = false;

          if (!lastLog) {
            // Nunca foi redirecionado: deve redirecionar e criar o primeiro log
            shouldRedirectForPreferences = true;
          } else if (lastLog.redirectedAt) {
            const redirectedAt = new Date(lastLog.redirectedAt);
            if (!Number.isNaN(redirectedAt.getTime())) {
              const diffDaysFromLastRedirect = differenceInCalendarDays(new Date(), redirectedAt);
              if (diffDaysFromLastRedirect >= 7) {
                shouldRedirectForPreferences = true;
              }
            }
          }

          if (shouldRedirectForPreferences) {
            await registerDealerRedirectLog(user.id);

            await sendDealerWithoutPrefersEvent({
              email: user.email,
              dealershipName: user.dealershipName,
              firstName: user.firstName,
              profileDealershipName: user.dealershipName,
              profileName:
                typeof user.getFullName === 'function'
                  ? user.getFullName()
                  : `${user.firstName || ''} ${user.lastName || ''}`.trim(),
              phoneNumber: user.phone,
            });

            // Redireciona para /preferencias (sem recadastro) na regra de 7 dias
            dealerPreferencesRedirectAlreadyHandled = true;
            history.push('/preferencias');
            return;
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(
            'Erro ao aplicar regra de redirecionamento de preferências (7 dias)',
            error
          );
        }
      }

      // Verifica se as preferências têm mais de 90 dias sem atualizar (recadastro)
      // Só verifica se a flag checkPreferences90Days estiver ativa
      if (checkPreferences90Days && !hasNoPreferences) {
        // Se não tem updatedAt, considera como se fosse muito antigo (mais de 90 dias)
        const rawUpdatedAt = userPreferences?.updatedAt || userPreferences?.updated_at;
        console.log('Preferences Check - rawUpdatedAt:', rawUpdatedAt);

        const parseUpdatedAt = value => {
          if (!value) return null;

          if (value instanceof Date && !Number.isNaN(value.getTime())) {
            return value;
          }

          if (typeof value === 'number') {
            const dateFromNumber = new Date(value);
            return Number.isNaN(dateFromNumber.getTime()) ? null : dateFromNumber;
          }

          if (typeof value === 'string') {
            const directParse = parseISO(value);
            if (isValidDate(directParse)) {
              return directParse;
            }

            const normalizedValue = value.replace(' ', 'T');
            const hasTimezone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(normalizedValue);
            const normalizedWithTimezone = hasTimezone ? normalizedValue : `${normalizedValue}Z`;
            const normalizedParse = parseISO(normalizedWithTimezone);

            if (isValidDate(normalizedParse)) {
              return normalizedParse;
            }

            const fallbackDate = new Date(value);
            return Number.isNaN(fallbackDate.getTime()) ? null : fallbackDate;
          }

          const fallbackDate = new Date(value);
          return Number.isNaN(fallbackDate.getTime()) ? null : fallbackDate;
        };

        const updatedAtDate = parseUpdatedAt(rawUpdatedAt);
        const today = new Date();
        console.log('Preferences Check - updatedAtDate:', updatedAtDate);
        console.log('Preferences Check - today:', today);

        // Se não tem updatedAt (null/undefined) ou data inválida, vai para recadastro
        if (!updatedAtDate || Number.isNaN(updatedAtDate.getTime())) {
          console.log('Preferences: updatedAt ausente ou inválido, redirecionando para recadastro');
          history.push('/preferencias?recadastro=true');
          return;
        }

        const diffDays = differenceInCalendarDays(today, updatedAtDate);
        console.log('Preferences Check - diffDays:', diffDays);

        if (diffDays > 90) {
          console.log(
            'Preferences: Preferências desatualizadas há mais de 90 dias, redirecionando para página'
          );
          console.log('Preferences: Executando history.push("/preferencias?recadastro=true")');
          history.push('/preferencias?recadastro=true');
        } else {
          console.log('Preferences Check - Não redirecionando: diffDays <= 90');
        }
      }
    };

    run();
  }, [
    userPreferencesLoaded,
    userPreferences,
    dispatch,
    history,
    checkPreferences90Days,
    history.location.pathname,
    user,
  ]);

  useEffect(() => {
    if (!enabledProfileVerification) return;

    const shouldShowModal = localStorage.getItem('showVerifyModal') === 'true';

    if (verificationProfile && shouldShowModal && verificationProfile.isVerified !== true) {
      history.push('/atualizar-perfil');
      localStorage.setItem('showVerifyModal', 'false');
    }
  }, [verificationProfile, enabledProfileVerification]);

  useEffect(() => {
    const userIdentified = JSON.parse(localStorage.getItem('user-identified'));

    if (!userIdentified) {
      localStorage.setItem('user-identified', JSON.stringify(true));

      _cio.identify({
        id: user?.email,
        email: user?.email,
        first_name: user?.dealershipName,
        created_at: new Date(),
      });
    }
  }, []);

  useEffect(() => {
    sendIdentify();
  }, []);

  const authenticateLogin = async () => {
    try {
      await checkToken();
      scrollTop();
      const isStore = String(user.role).toLowerCase() === 'loja';
      if (!loadingHistoricsAuctions && !historicsLoaded && allCarsFetched && isStore) {
        auctionsActions.fetchAuctionsHistory();
      }
    } catch (error) {
      const currentPath = history.location.pathname + history.location.search;
      if (currentPath !== '/login') {
        sessionStorage.setItem('redirectAfterLogin', currentPath);
      }
      dispatch(deauthenticate(() => history.push('/login')));
    }
  };

  const showNewOffersFilters = useCallback(async () => {
    if (filterList.length > 0) {
      setType('category');
      setIsOpen(true);
    } else {
      auctionsActions.handleFilters({ showNewOffersFilters: true });
      const { id, dealershipName, email } = user;
      sendEvent('filterTracker', {
        dealershipId: id,
        dealershipEmail: email,
        dealershipName: dealershipName,
        eventCategory: 'Filters',
        eventAction: 'Open filters',
        eventLabel: 'New offers filter',
      });
    }

    auctionsActions.handleFilters({ showNewOffersFilters: true });

    setStaticAuctions(auctions.newOffers);

    const { id, dealershipName, email } = user;
    sendEvent('filterTracker', {
      dealershipId: id,
      dealershipEmail: email,
      dealershipName: dealershipName,
      eventCategory: 'Filters',
      eventAction: 'Open filters',
      eventLabel: 'New offers filter',
    });
  }, [filterList, auctions]);

  function closeNewOffersFilters() {
    auctionsActions.handleFilters({ showNewOffersFilters: false });
  }

  const now = Date.now(); // Obtém o timestamp atual

  const { highlightOffers, newOffers, recommendedOffers } = useMemo(() => {
    let recommendedOffers = auctions.newOffers.filter(car => recommendedCars.includes(car._id));

    let newOffers = [...auctions.newOffers.filter(car => !recommendedCars.includes(car._id))];

    if (filterList.length > 0) newOffers = [...filtredAuctions.data];

    if (ui.filters.newOffersFiltersApplyed) newOffers = [...auctions.newOffers];

    let highlightOffers = defineSupperOfferAuctions(newOffers, {
      supperOfferMaximumSize: 15,
    }).filter(car => car.auction.isSupperOffer);

    // Filtrar veículos com hasD2D true dos highlightOffers
    highlightOffers = highlightOffers.filter(car => !car.summary?.hasD2D);

    highlightOffers = sortAuctionsByFilter(highlightOffers, ui.sortFilterParam);

    newOffers = sortAuctionsByFilter(newOffers, ui.sortFilterParam);

    return { highlightOffers, newOffers, recommendedOffers };
  }, [
    recommendedCars,
    filtredAuctions,
    filterList,
    auctions,
    ui.sortFilterParam,
    ui.filters,
    benefitsClub,
    now,
  ]);

  const filterOffers = (offers, keepClubTag = false) => {
    return offers
      .map(offer => {
        if (!offer?.auction?.startTime || !offer?.auction?.expectedEndTime) {
          return null;
        }

        const startTime = new Date(offer.auction.startTime).getTime();
        const endTime = new Date(offer.auction.expectedEndTime).getTime();

        if (isNaN(startTime) || isNaN(endTime)) {
          return null;
        }

        // Liberação para não-clube é baseada na subida de lotes: o veículo subiu em
        // determinado dia/lote e só é liberado para não-clube no generalReleaseTime
        // daquele lote. Se o dia/slot foi desativado depois da subida, continua
        // mostrando ('always'). Enquanto a config não carrega ('unknown'), mantém o
        // fallback por tempo fixo (startTime + 1h).
        const release = resolveNonClubRelease({ days: launchWindowsDays, startTime, now });
        let isLiberatedTime;
        if (release.status === 'gated') {
          isLiberatedTime = now >= release.epoch;
        } else if (release.status === 'always') {
          isLiberatedTime = true;
        } else {
          isLiberatedTime = now >= startTime + 60 * 60 * 1000;
        }

        const isLiberated = benefitsClub ? true : isLiberatedTime;

        // Se o usuário não tem clube e a oferta não foi liberada pelo tempo, não mostrar
        if (!benefitsClub && !isLiberatedTime) {
          return null;
        }

        // Se não deve manter o tag do clube (highlight), retorna null para ofertas não liberadas
        if (!keepClubTag && !isLiberatedTime) {
          return null;
        }

        return {
          ...offer,
          canShowTagClube: benefitsClub && !isLiberatedTime,
          isLiberated,
        };
      })
      .filter(Boolean);
  };

  const filteredRecommendedOffers = filterOffers(recommendedOffers, true);
  const filteredNewOffers = filterOffers(newOffers, true);
  const filteredHighlightOffers = filterOffers(highlightOffers, false);

  // MOCKS
  // const filteredNewOffers = filterOffers(mockAuctions);
  // const filteredRecommendedOffers = filterOffers(mockAuctions);
  // const filteredHighlightOffers = filterOffers(mockAuctions);

  const upcomingDisputasBaseUrl = AppConstants.UPCOMING_DISPUTES_IFRAME_BASE_URL || '';
  const MIN_HEIGHT_IFRAME = 'calc(100vh - 155px)';
  const upcomingDisputasIframeUrl = useMemo(() => {
    const dealerId = user?.id;
    if (!dealerId || !upcomingDisputasBaseUrl) return upcomingDisputasBaseUrl;
    const hasQuery = upcomingDisputasBaseUrl.includes('?');
    return `${upcomingDisputasBaseUrl}${hasQuery ? '&' : '?'}dealer_id=${dealerId}`;
  }, [user?.id, upcomingDisputasBaseUrl]);
  const upcomingDisputasWrapperRef = useRef(null);

  useEffect(() => {
    if (!enabledProximasDisputas) return;
    fetchUpcomingDisputesCount()
      .then(setUpcomingDisputesCount)
      .catch(error => console.error(error));
  }, [enabledProximasDisputas]);

  useEffect(() => {
    const el = upcomingDisputasWrapperRef.current;
    if (!el || state.tab !== 3) return;
    const handleWheel = e => {
      const main = document.getElementById('base-layout');
      if (!main) return;
      e.preventDefault();
      e.stopPropagation();
      main.scrollTop += e.deltaY;
    };
    el.addEventListener('wheel', handleWheel, { passive: false, capture: true });
    return () => el.removeEventListener('wheel', handleWheel, { capture: true });
  }, [state.tab]);

  const tabsData = {
    showNotifyIcon: isParticipatingInNewAuctions,
    participatingCount: auctions.participatingAuctions.length,
    // Com filtro de categoria ativo, filtredAuctions.data (base do filteredNewOffers)
    // já contém TODOS os carros que casam, inclusive os recomendados. Somar
    // filteredRecommendedOffers aqui duplicaria a contagem — por isso só somamos
    // os recomendados quando não há filtro ativo.
    newOffersCount:
      filterList.length > 0
        ? benefitsClub
          ? filteredNewOffers.length
          : filteredNewOffers.filter(offer => !offer.canShowTagClube).length
        : benefitsClub
        ? filteredNewOffers.length + filteredRecommendedOffers.length
        : filteredNewOffers.filter(offer => !offer.canShowTagClube).length +
          filteredRecommendedOffers.filter(offer => !offer.canShowTagClube).length,
    upcomingDisputesCount,
    activeTab: state.tab,
    onClickTab0: () => setState({ tab: 0 }),
    onClickTab1: () => {
      setState({ tab: 1 });
      auctionsActions.IsParticipatingInNewAuctions(false);
    },
    onClickTab2: () => {
      setState({ tab: 2 });
    },
    ...(enabledProximasDisputas && { onClickTab3: () => setState({ tab: 3 }) }),
  };

  window.addEventListener('resize', () => {
    if (window.screen.width <= 1024 && window.screen.width >= 768) {
      return setDisplayWidth('md');
    }

    window.screen.width < 768 ? setDisplayWidth('sm') : setDisplayWidth('lg');
  });

  const renderingPreferences = (
    <PreferenceButton
      onClick={() => history.push('/preferencias')}
      style={enabledRecommended && { marginBottom: '0px' }}
    >
      Alterar preferências
    </PreferenceButton>
  );

  if (allRequestOnGoing || loadingHistoricsAuctions || userProfileLoading)
    return <Loading centered />;

  return (
    <>
      <CannotSelectWithActiveCategoriesModal
        isOpen={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
        type={type}
      />
      <Layout tabs={true} tabsData={tabsData} user={user} scroll={state.tab !== 3}>
        {state.tab === 3 ? (
          <div
            ref={upcomingDisputasWrapperRef}
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              minHeight: MIN_HEIGHT_IFRAME,
              overflow: 'auto',
            }}
          >
            <iframe
              src={upcomingDisputasIframeUrl}
              frameBorder={0}
              width="100%"
              height="100%"
              allowTransparency
              title="Próximas disputas"
              style={{
                display: 'block',
                border: 'none',
                width: '100%',
                height: '100%',
                minHeight: MIN_HEIGHT_IFRAME,
              }}
            />
          </div>
        ) : (
          <Content>
            <UserFavoriteInspectionsContextProvider service={favoriteService} notify={console}>
              {state.tab === 0 && enabledDisputa360Banner && (
                <Box width="100%" pb={3}>
                  <Flex className="container" mx="auto" p={1} flexWrap="wrap">
                    <Disputa360Banner />
                  </Flex>
                </Box>
              )}

              {state.tab === 0 && enabledRecommended && (
                <Box width="100%" pb={3}>
                  <Flex className="container" mx="auto" p={1} flexWrap="wrap">
                    <FilterNavigation
                      handleFilterButton={showNewOffersFilters}
                      tab={0}
                      recommendedCars={recommendedCars}
                    />
                  </Flex>
                </Box>
              )}

              {state.tab === 0 &&
                !!filteredRecommendedOffers.length &&
                !filterList.length &&
                enabledOrderCars && (
                  <Recommended style={enabledRecommended ? {} : { backgroundColor: '#003a76' }}>
                    <Recommended.Content>
                      {enabledRecommended ? (
                        <>
                          <ListsTitle color="#fff" style={{ marginTop: 32, marginBottom: 12 }}>
                            <RecommendedIcon color="#003a76" />
                            <Recommended.Title style={{ color: '#2f3741', fontSize: 24 }}>
                              Recomendados para você
                            </Recommended.Title>
                            {window.screen.width > 768 && renderingPreferences}
                          </ListsTitle>
                          {window.screen.width < 768 && renderingPreferences}
                        </>
                      ) : (
                        <>
                          <ListsTitle color="#fff" style={{ marginTop: 32, marginBottom: 12 }}>
                            <RecommendedIcon color="#ffed1c" />
                            <h5>Recomendados para você</h5>
                          </ListsTitle>
                          <PreferenceButton
                            onClick={() => history.push('/preferencias')}
                            style={{ color: '#fff', fontSize: 14 }}
                          >
                            Alterar preferências
                          </PreferenceButton>
                        </>
                      )}

                      {enabledRecommended ? (
                        <NewRecommendedList
                          auctions={filteredRecommendedOffers}
                          isRecommended={true}
                        />
                      ) : (
                        <NewCarousel auctions={filteredRecommendedOffers} isRecommended={true} />
                      )}
                    </Recommended.Content>
                  </Recommended>
                )}

              <Box width="100%" pb={3}>
                <Flex
                  className="container"
                  mx="auto"
                  p={1}
                  flexWrap="wrap"
                  justifyContent={state.tab === 1 ? 'center' : ''}
                >
                  <WarningNotificationSnack shouldShow={isProfileOutdated} />

                  {state.tab === 0 ? (
                    filterList.length === 0 &&
                    filteredNewOffers.length < 1 &&
                    recommendedOffers.length < 1 ? (
                      <EmptyState
                        tab={0}
                        showFinCred={true}
                        enabledRecommended={enabledRecommended}
                      />
                    ) : (
                      <NewOffersContainer>
                        {!enabledRecommended && (
                          <FilterNavigation
                            handleFilterButton={showNewOffersFilters}
                            tab={0}
                            recommendedCars={recommendedCars}
                          />
                        )}
                        <NewOffersBody filtersOpen={ui.filters.showNewOffersFilters}>
                          {ui.filters.showNewOffersFilters && (
                            <FilterSide>
                              <FilterSide.Content>
                                <FilterSide.Content.Close onClick={closeNewOffersFilters}>
                                  <MdClose />
                                </FilterSide.Content.Close>
                                <NewOffersFilters />
                              </FilterSide.Content>
                            </FilterSide>
                          )}
                          <NewOffersBody.Content>
                            {(filteredNewOffers.filter(offer => offer.canShowTagClube).length > 0 ||
                              filteredRecommendedOffers.filter(offer => offer.canShowTagClube)
                                .length > 0) && (
                              <>
                                <ListsTitle>
                                  <img src={clubeSession} alt="clubeSession" />
                                  <h5>Acesso antecipado</h5>
                                </ListsTitle>
                                <ClubeListscaption>
                                  <h6>
                                    Confira os carros disponíveis para você no acesso antecipado.
                                  </h6>
                                  <p>
                                    Aproveite a vantagem para sair na frente e garantir os melhores
                                    negócios!
                                  </p>
                                </ClubeListscaption>
                                <ClubeOffersList
                                  auctions={
                                    filterList.length > 0
                                      ? filteredNewOffers.filter(offer => offer.canShowTagClube)
                                      : [
                                          ...filteredNewOffers.filter(
                                            offer => offer.canShowTagClube
                                          ),
                                          ...filteredRecommendedOffers.filter(
                                            offer => offer.canShowTagClube
                                          ),
                                        ]
                                  }
                                  isClubOffers={true}
                                />
                              </>
                            )}
                          </NewOffersBody.Content>
                          <NewOffersBody.Content>
                            {filteredHighlightOffers.length > 0 && !filterList.length && (
                              <>
                                <ListsTitle>
                                  <img src={FireIcon} alt="fire" />
                                  <h5>Ofertas em destaque</h5>
                                </ListsTitle>
                                {/* <NewCarousel auctions={highlightOffers} isHighlight /> */}
                                <HighlightOffersList auctions={filteredHighlightOffers} />
                              </>
                            )}

                            {(recommendedOffers.length > 0 || filteredHighlightOffers.length > 0) &&
                              filteredNewOffers.length > 0 &&
                              !filteredNewOffers.length && (
                                <ListsTitle>
                                  <h5>Mais ofertas</h5>
                                </ListsTitle>
                              )}

                            {!!filteredNewOffers.length && (
                              <ListsTitle>
                                <h5>
                                  {filteredNewOffers.length}{' '}
                                  <span style={{ fontWeight: 400 }}>resultados encontrados</span>
                                </h5>
                              </ListsTitle>
                            )}

                            {filterList.length > 0 && filteredNewOffers.length === 0 && (
                              <ListsTitle>
                                <h5>
                                  <span style={{ fontWeight: 400 }}>
                                    Nenhum veículo corresponde a todas as categorias selecionadas.
                                  </span>
                                </h5>
                              </ListsTitle>
                            )}

                            {filteredNewOffers.length === 0 && displaySimulationBanner ? (
                              <CarList>
                                <FincredCard />
                              </CarList>
                            ) : (
                              <NewOffersList
                                auctions={filteredNewOffers.filter(offer => !offer.canShowTagClube)}
                                newOffers={true}
                              />
                            )}

                            {/* {!!filterList.length && (
                          <Box style={{ marginBottom: '3rem', textAlign: 'center' }}>
                            <Button
                              style={{ margin: '1rem auto' }}
                              onClick={() => {
                                clearFilter();
                                dispatch(uiActionsTypes.clearCategoryFilter());
                                document
                                  .getElementById('base-layout')
                                  .scrollTo({ top: 0, behavior: 'smooth' });
                              }}
                            >
                              Ver outras ofertas
                            </Button>
                          </Box>
                        )} */}

                            {ui.filters.showNewOffersLoading && (
                              <LoadingAuctions>
                                <img src={LoadingGif} alt="Carregando" />
                              </LoadingAuctions>
                            )}
                          </NewOffersBody.Content>
                        </NewOffersBody>
                      </NewOffersContainer>
                    )
                  ) : null}

                  {state.tab === 1 ? (
                    Array.isArray(auctions?.participatingAuctions) &&
                    auctions?.participatingAuctions?.length < 1 ? (
                      <EmptyState
                        title="Você não está participando de nenhum leilão"
                        description="Participe de leilões para visualizar aqui os status de cada um dos seus carros."
                        buttons={[
                          {
                            label: 'Ver leilões ativos',
                            action: () => {
                              setState({ tab: 0 });
                            },
                            variant: 'ghost.default',
                          },
                        ]}
                      />
                    ) : (
                      <div style={{ width: '100%' }}>
                        <ParticipatingAuctionsList
                          auctions={auctions.participatingAuctions}
                          displayWidth={displayWidth}
                        />
                        {ui.filters.showParticipatingLoading && (
                          <LoadingAuctions>
                            <img src={LoadingGif} alt="Carregando" />
                          </LoadingAuctions>
                        )}
                        {ui.filters.participatingErrors && (
                          <ModalTemplate
                            handleCloseModal={() =>
                              auctionsActions.handleFilters({ participatingErrors: '' })
                            }
                          >
                            <p>{ui.filters.participatingErrors}</p>
                          </ModalTemplate>
                        )}
                      </div>
                    )
                  ) : null}

                  {state.tab === 2 && (
                    <NotificationsList goToPageOne={() => tabsData.onClickTab0()} />
                  )}
                </Flex>

                <ConfirmationModal
                  id="autobid-confirmation-modal"
                  show={ui.showConfirmationModal}
                  message={ui.confirmationModalMessage}
                  toggle={() => {
                    uiActions.toggleAutoBidConfirmation(false);
                  }}
                  confirmationToggle={t => {
                    uiActions.toggleAutoBidConfirmation(t);
                  }}
                />
                <MakeBidConfirmationModal
                  id="make-bid-confirmation-modal"
                  toggle={auctionsActions.toggleMakeBidConfirmationModal}
                  show={auctions.showMakeBidConfirmationModal}
                  selectedCar={auctions.confirmationCar}
                />

                {canShowFreeShippingDialog() && <FreeShippingDialog />}
              </Box>
            </UserFavoriteInspectionsContextProvider>
          </Content>
        )}
        {ui.filters.showNewOffersFilters && <MobileNewOffersFilters />}
      </Layout>
    </>
  );
};

AuctionsLayout.propTypes = {
  user: PropTypes.object.isRequired,
  auctions: PropTypes.object.isRequired,
  ui: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  allRequestOnGoing: PropTypes.bool,
  loadingHistoricsAuctions: PropTypes.bool,
  historicsLoaded: PropTypes.bool,
  allCarsFetched: PropTypes.bool,
  isParticipatingInNewAuctions: PropTypes.bool,
  isProfileOutdated: PropTypes.bool,
  auctionsActions: PropTypes.object.isRequired,
  uiActions: PropTypes.object.isRequired,
  listAutoBidVehicles: PropTypes.func,
  listAllAutoBidVehicles: PropTypes.func,
};

export function mapStateToProps(state) {
  return {
    ui: state.ui,
    auctions: state.auctions,
    user: state.authentication.user,
    allCarsFetched: state.auctions.allCarsFetched,
    historicsLoaded: state.auctions.historicsLoaded,
    allRequestOnGoing: state.auctions.allRequestOnGoing,
    isProfileOutdated: state.user.isRegistrationOutdate,
    loadingHistoricsAuctions: state.auctions.loadingHistoricsAuctions,
    isParticipatingInNewAuctions: state.ui.isParticipatingInNewAuctions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    uiActions: bindActionCreators(uiActionsTypes, dispatch),
    auctionsActions: bindActionCreators(auctionsActionsTypes, dispatch),
    listAutoBidVehicles: bindActionCreators(listAutoBidVehicles, dispatch),
    listAllAutoBidVehicles: bindActionCreators(listAllAutoBidVehicles, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuctionsLayout));
